module.exports = __webpack_public_path__ + "img/iconBackWhite.3808b713.svg";